import React from 'react'
import VecIcon from 'react-native-vector-icons/Feather';
import {IconProps} from 'react-native-vector-icons/Icon';

export const Icon = (props: IconProps) => <VecIcon {...props} />
